/*
	roundingValue(price)
		- price: float
	
	display(price, currency)
		- price: float
		- currency: string

	displayRounded(price, currency)
		- price: float
		- currency: string

	displayRounding(price, currency)
		- price: float
		- currency: string
*/
//======================================================//
//														//
//						CALCULATION						//
//														//
//======================================================//

//--------- OBTAIN ROUNDING TO NEAREST 5 CENTS ---------//
function roundingValue(price){
	price = parseFloat(price);
	// Var declaration
	var ringgit, cents;
	var centDigits;

	// Calculation
	ringgit = Math.floor(price);
	cents = Math.round(100*(price - ringgit));
	centDigits = cents%10;

	if (centDigits < 3){
		return centDigits/100;
	}
	else if (centDigits < 6){
		return (centDigits - 5)/100;
	}
	else if (centDigits < 8){
		return (5 -  centDigits)/100;
	}
	else{
		return (10 - centDigits)/100;
	}
}


//-------------- ROUND TO NEAREST 5 CENTS --------------//
function roundedValue(price){
	price = parseFloat(price);
	return price + roundingValue(price);
}



//======================================================//
//														//
//						DISPLAY							//
//														//
//======================================================//

//---------------------- PRICE -------------------------//
function display(price, currency){
	price = parseFloat(price);
	// Mode
	var currency = currency || "";
	var ringgit, cents;

	// Obtains number
	if (price<0){
		currency = "- " + currency;
		price = Math.abs(price);
	}

	// Calculation
	ringgit = Math.floor(price);
	cents = Math.round(100*(price - ringgit));
	if (cents<10){
		cents = "0" + cents.toString(); 
	}

	// Output
	return currency + " " + ringgit + "." + cents;
}


//---------------------- ROUNDED -----------------------//
function displayRounded(price, currency){
	price = parseFloat(price);
	return display(roundedValue(price), currency);
}

//---------------------- ROUNDING ----------------------//
function displayRounding(price, currency){
	price = parseFloat(price);
	return display(roundingValue(price), currency);
}



//======================================================//
//														//
//						EXPORT							//
//														//
//======================================================//
export default{
	roundingValue,
	roundedValue,
	display,
	displayRounded,
	displayRounding
}



// WEBPACK FOOTER //
// ./src/assets/js/priceManager.js